import React from "react";
import "./Footer.css"; // Import the CSS file

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      Copyright © 1996 – {currentYear} Air Products and Chemicals, Inc. All
      Rights Reserved. v{process.env.REACT_APP_VERSION || '0.1.0'}
    </footer>
  );
};

export default Footer;
